<div class="modal_dialog print-barcode-modal">
    <div class="modal_header">
        <h2>{{ 'PrintBarcode' | translate }}</h2>
        <button class="btnn close_icon" type="button" (click)="onCancel()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="modal_body">
        <!-- Product Information -->
        <div class="product-info">
            <h3>{{ data.productName }}</h3>
            <div class="shelf-details">
                <div class="detail-row">
                    <span class="label">{{ 'Shelf' | translate }}:</span>
                    <span class="value">{{ data.shelf.shelve }}</span>
                </div>
                <div class="detail-row">
                    <span class="label">{{ 'Zone' | translate }}:</span>
                    <span class="value">{{ data.shelf.zoneAbbreviation }}</span>
                </div>
                <div class="detail-row">
                    <span class="label">{{ 'Level' | translate }}:</span>
                    <span class="value">{{ data.shelf.levelName }}</span>
                </div>
                <div class="detail-row">
                    <span class="label">{{ 'Allocated Quantity' | translate }}:</span>
                    <span class="value">{{ data.shelf.allocatedQuantity }}</span>
                </div>
            </div>
        </div>

        <!-- Barcode Items -->
        <div class="barcode-items">
            <h4>{{ 'ItemsToPrint' | translate }}</h4>
            <div class="items-list">
                <div class="barcode-item" *ngFor="let item of getBarcodeItems(); let i = index">
                    <div class="item-info">
                        <div class="item-header">
                            <span class="item-number">{{ 'Product' | translate }} {{ i + 1 }}</span>
                            <span class="quantity-badge">{{ 'Quantity' | translate }}: {{ item.quantity }}</span>
                        </div>
                        <div class="item-details">
                            <div class="detail-row">
                                <span class="label">{{ 'ShelfCode' | translate }}:</span>
                                <span class="value">{{ item.shelfCode }}</span>
                            </div>
                            <div class="detail-row">
                                <span class="label">{{ 'SerialNumber' | translate }}:</span>
                                <span class="value">{{ item.serialNumber }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="item-actions">
                        <div class="action-buttons">
                            <button 
                                mat-raised-button 
                                class="print-btn" 
                                (click)="onPrint(item)">
                                <mat-icon>print</mat-icon>
                                <span>{{ 'Print' | translate }}</span>
                            </button>
                            <button 
                                mat-raised-button 
                                class="copy-btn" 
                                (click)="copyToClipboard(item.serialNumber)"
                                [title]="'CopySerialNumberToClipboard' | translate">
                                <mat-icon>content_copy</mat-icon>
                                <span>{{ 'Copy' | translate }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal_footer">
        <button 
            mat-button 
            class="cancel-btn" 
            (click)="onCancel()">
            {{ 'Cancel' | translate }}
        </button>
        <!-- <button 
            mat-button 
            class="primary-btn" 
            (click)="onPrintAll()">
            {{ 'PrintAll' | translate }}
        </button> -->
    </div>
</div> 